const icon = require('vue-svgicon');
icon.register({
    'arrow-right-round': {
        width: 40,
        height: 40,
        viewBox: '0 0 40 40',
        data: `<circle pid="0" cx="20" cy="20" r="19.5" _stroke="#000"/><path pid="1" d="M26.995 19.958a.47.47 0 01.107.257c0 .01.007.019.007.029l.002.006-.002.008c0 .007-.003.012-.003.018a.502.502 0 01-.13.312c-.006.007-.003.018-.01.025-.007.007-.018.004-.025.01-.006.006-.017.005-.025.01l-5.562 5.056a.496.496 0 01-.702-.7l4.655-4.231h-11.91a.508.508 0 010-1.015h11.91l-4.655-4.23a.495.495 0 11.702-.701l5.534 5.03c.009.006.013.016.02.022.018.014.042.008.058.024.02.02.013.048.03.07z" _fill="#000"/>`,
    },
});
